export { customIconMap } from "./custom-icon-map";
export type { CustomIconName } from "./custom-icon-map";
